var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "DPRModal",
            size: "lg",
            "content-class": "sub-menu-bg-blue-transparent dpr-modal",
            "body-class": "scroll-Container",
            title: "Daily Productivity Report",
            "hide-footer": "",
            scrollable: "",
          },
          on: {
            show: function ($event) {
              return _vm.initDPR()
            },
            hidden: function ($event) {
              return _vm.closeDPR()
            },
          },
        },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                { staticClass: "p-3" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "modal-card-solid-blue",
                          attrs: {
                            "header-html": "<b>Logistics</b>",
                            "no-body": "",
                          },
                        },
                        [
                          _c(
                            "b-form-group",
                            { staticClass: "px-3 py-2" },
                            [
                              _c("label", [_vm._v("Date *")]),
                              _vm._v(" "),
                              _c("b-form-input", {
                                attrs: {
                                  id: "date",
                                  type: "date",
                                  placeholder: "date",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.calculateJday()
                                  },
                                },
                                model: {
                                  value: _vm.form.date,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "date", $$v)
                                  },
                                  expression: "form.date",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            { staticClass: "px-3 py-2" },
                            [
                              _c("label", [_vm._v("Vehicle *")]),
                              _vm._v(" "),
                              _c(
                                "b-form-select",
                                {
                                  model: {
                                    value: _vm.form.vehicle_id,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "vehicle_id", $$v)
                                    },
                                    expression: "form.vehicle_id",
                                  },
                                },
                                _vm._l(_vm.vehicles, function (system) {
                                  return _c(
                                    "option",
                                    {
                                      key: system.id,
                                      domProps: { value: system.id },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(system.vehicle_name) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            { staticClass: "px-3 py-2" },
                            [
                              _c("label", [_vm._v("Location")]),
                              _vm._v(" "),
                              _c("b-form-select", {
                                attrs: { options: _vm.listOfCountries },
                                model: {
                                  value: _vm.form.collectedLocationCountry,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "collectedLocationCountry",
                                      $$v
                                    )
                                  },
                                  expression: "form.collectedLocationCountry",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          ["United States of America", "Canada"].includes(
                            _vm.form.collectedLocationCountry
                          )
                            ? _c(
                                "b-form-group",
                                { staticClass: "px-3 py-2" },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "collected_locations" } },
                                    [_vm._v("Collected")]
                                  ),
                                  _vm._v(" "),
                                  _c("multiselect", {
                                    attrs: {
                                      id: "collected_locations",
                                      placeholder: "",
                                      "close-on-select": false,
                                      disabled: _vm.formDisabledControl,
                                      multiple: true,
                                      options: _vm.getLocationOptions(),
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "selection",
                                          fn: function ({ values, isOpen }) {
                                            return [
                                              values.length && !isOpen
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "multiselect__single",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            values.length
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            values.length > 1
                                                              ? "options"
                                                              : "option"
                                                          ) +
                                                          " selected\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3042344257
                                    ),
                                    model: {
                                      value: _vm.form.collectedLocation,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "collectedLocation",
                                          $$v
                                        )
                                      },
                                      expression: "form.collectedLocation",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            { staticClass: "px-3 py-2" },
                            [
                              _c("label", [_vm._v("Hotel Location *")]),
                              _vm._v(" "),
                              _c("b-form-input", {
                                attrs: { id: "hotelLocation" },
                                model: {
                                  value: _vm.form.hotelLocation,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "hotelLocation", $$v)
                                  },
                                  expression: "form.hotelLocation",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            { staticClass: "px-3 py-2" },
                            [
                              _c("label", [_vm._v("Jday")]),
                              _vm._v(" "),
                              _c("b-form-input", {
                                staticClass: "text-input",
                                attrs: {
                                  id: "jdate",
                                  disabled: "",
                                  show: _vm.jdate,
                                },
                                model: {
                                  value: _vm.form.jdate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "jdate", $$v)
                                  },
                                  expression: "form.jdate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "xs-spacing" },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "modal-card-solid-blue",
                          attrs: {
                            "header-html": "<b>Crew Information</b>",
                            "no-body": "",
                          },
                        },
                        [
                          _c(
                            "b-form-group",
                            { staticClass: "px-3 py-2" },
                            _vm._l(_vm.operatorInputs, function (input, index) {
                              return _c(
                                "div",
                                { attrs: { id: "operatorSelectionContainer" } },
                                [
                                  index == 0
                                    ? _c(
                                        "label",
                                        {
                                          key: index,
                                          attrs: {
                                            for: "operatorSelect",
                                            value: index,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Operator " +
                                              _vm._s(index + 1) +
                                              " *\n                "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "operatorSelect",
                                            value: index,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Operator " +
                                              _vm._s(index + 1) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-select",
                                    {
                                      attrs: {
                                        value: index,
                                        id: "operatorSelect",
                                      },
                                      model: {
                                        value:
                                          _vm.form[
                                            "operator" + (index + 1) + "_id"
                                          ],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "operator" + (index + 1) + "_id",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form['operator' + (index + 1) + '_id']",
                                      },
                                    },
                                    _vm._l(_vm.operators, function (operator) {
                                      return _c(
                                        "option",
                                        {
                                          key: operator.id,
                                          attrs: {
                                            disabled: _vm.operatorDisabled(
                                              operator.id
                                            ),
                                          },
                                          domProps: { value: operator.id },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(operator.name) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          this.numDriversError
                            ? _c(
                                "div",
                                {
                                  staticClass: "alert alert-danger",
                                  attrs: { role: "alert" },
                                },
                                [
                                  _c("small", [
                                    _vm._v(_vm._s(this.numDriversError)),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "pb-4" },
                            [
                              _c("b-col", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center",
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "outline-success",
                                          disabled: _vm.addDriverBtnDisabled,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addOperator()
                                          },
                                        },
                                      },
                                      [
                                        _c("fa", {
                                          attrs: { icon: ["fas", "plus"] },
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "pl-2" }, [
                                          _vm._v("Operator"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-col", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center",
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "outline-danger" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeDriver()
                                          },
                                        },
                                      },
                                      [
                                        _c("fa", {
                                          attrs: { icon: ["fas", "minus"] },
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "pl-2" }, [
                                          _vm._v("Operator"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "p-3" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "modal-card-solid-blue",
                          attrs: {
                            "header-html": "<b>Acquisition Information</b>",
                            "no-body": "",
                          },
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "px-3 pt-2" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "collection_hours" } },
                                        [_vm._v("Collection Hours")]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "collection_hours",
                                          type: "number",
                                          step: ".5",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.collectionHoursChange()
                                          },
                                        },
                                        model: {
                                          value: _vm.form.truckHours,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "truckHours",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "form.truckHours",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "office_hours" } },
                                        [_vm._v("Office Hours")]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "office_hours",
                                          type: "number",
                                          step: ".5",
                                          pattern: "^\\d*(\\.\\d{0,2})?$",
                                        },
                                        model: {
                                          value: _vm.form.officeHours,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "officeHours",
                                              $$v
                                            )
                                          },
                                          expression: "form.officeHours",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "truck_hours" } },
                                        [_vm._v("Truck Hours")]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "truck_hours",
                                          type: "number",
                                          step: ".5",
                                        },
                                        model: {
                                          value: _vm.form.newTruckHours,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "newTruckHours",
                                              $$v
                                            )
                                          },
                                          expression: "form.newTruckHours",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.showCollectionHoursAlert
                            ? _c(
                                "b-row",
                                { staticClass: "px-3 py-2" },
                                [
                                  _c("b-col", [
                                    _c(
                                      "div",
                                      { staticClass: "alert alert-warning" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "Explain collection hours less than 6.5 in comments"
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "px-3 py-2" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c("label", { attrs: { for: "gtps" } }, [
                                    _vm._v("Number of GTP's"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-select",
                                    {
                                      attrs: { id: "gtps" },
                                      model: {
                                        value: _vm.form.gtps,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "gtps", $$v)
                                        },
                                        expression: "form.gtps",
                                      },
                                    },
                                    [
                                      _c("option", [_vm._v("NA")]),
                                      _vm._v(" "),
                                      _c("option", [_vm._v("1")]),
                                      _vm._v(" "),
                                      _c("option", [_vm._v("2")]),
                                      _vm._v(" "),
                                      _c("option", [_vm._v("3")]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "px-3 py-2" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c("label", { attrs: { for: "gtps" } }, [
                                    _vm._v("GTP Drive By"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-select",
                                    {
                                      attrs: { id: "gtps" },
                                      model: {
                                        value: _vm.form.gtpsDriveBy,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "gtpsDriveBy", $$v)
                                        },
                                        expression: "form.gtpsDriveBy",
                                      },
                                    },
                                    [
                                      _c("option", [_vm._v("NA")]),
                                      _vm._v(" "),
                                      _c("option", [_vm._v("1")]),
                                      _vm._v(" "),
                                      _c("option", [_vm._v("2")]),
                                      _vm._v(" "),
                                      _c("option", [_vm._v("3")]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "px-3 py-2" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c("label", { attrs: { for: "gtps" } }, [
                                    _vm._v("GTP Name"),
                                  ]),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    model: {
                                      value: _vm.form.gtpsName,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "gtpsName", $$v)
                                      },
                                      expression: "form.gtpsName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "px-3 pt-2 pb-3" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c("label", { attrs: { for: "road_type" } }, [
                                    _vm._v("Road Type"),
                                  ]),
                                  _vm._v(" "),
                                  _c("multiselect", {
                                    attrs: {
                                      id: "road_type",
                                      "track-by": "id",
                                      label: "type",
                                      multiple: "",
                                      placeholder: "",
                                      "close-on-select": false,
                                      disabled: _vm.formDisabledControl,
                                      options: _vm.roadTypes,
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "selection",
                                        fn: function ({ values, isOpen }) {
                                          return [
                                            values.length && !isOpen
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "multiselect__single",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(values.length) +
                                                        " " +
                                                        _vm._s(
                                                          values.length > 1
                                                            ? "options"
                                                            : "option"
                                                        ) +
                                                        " selected\n                    "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.form.selectedRoadTypes,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "selectedRoadTypes",
                                          $$v
                                        )
                                      },
                                      expression: "form.selectedRoadTypes",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "modal-card-solid-blue",
                          attrs: {
                            "header-html": "<b>Productivity</b>",
                            "no-body": "",
                          },
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "px-3 pt-2" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "downtimeReason" } },
                                        [_vm._v(" Reason for full down day ")]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-select", {
                                        attrs: {
                                          id: "downtimeReason",
                                          disabled:
                                            _vm.reasonDownFullDayInputDisabled,
                                          options: _vm.downtimeReasons,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.downFullDayChange()
                                          },
                                        },
                                        model: {
                                          value: _vm.form.downtimeReason,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "downtimeReason",
                                              $$v
                                            )
                                          },
                                          expression: "form.downtimeReason",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "px-3 pt-2" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "partialDowntimeReason",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Reason for partial down time\n                  "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-select", {
                                        attrs: {
                                          id: "partialDowntimeReason",
                                          disabled:
                                            _vm.reasonPartialDowntimeInputDisabled,
                                          options: _vm.downtimeReasons,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.partialDowntimeReasonChange()
                                          },
                                        },
                                        model: {
                                          value: _vm.form.partialDowntimeReason,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "partialDowntimeReason",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.partialDowntimeReason",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "px-3 pt-2" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { id: "numHoursPartialForm" } },
                                    [
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "numHoursPartialDowntime",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Partial down time hours\n                    "
                                          ),
                                          _vm.form.partialDowntimeReason != null
                                            ? _c("span", [_vm._v(" * ")])
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        attrs: {
                                          disabled:
                                            _vm.partialDowntimeHoursDisabled,
                                          type: "number",
                                          step: ".5",
                                          id: "numHoursPartialDowntime",
                                        },
                                        model: {
                                          value:
                                            _vm.form.numHoursPartialDowntime,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "numHoursPartialDowntime",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.numHoursPartialDowntime",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "p-3 row" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "modal-card-solid-blue",
                          attrs: {
                            "header-html": "<b>Issues</b>",
                            "no-body": "",
                          },
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "px-3 py-2 row" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c("label", { attrs: { for: "issues" } }, [
                                    _vm._v("Issues"),
                                  ]),
                                  _vm._v(" "),
                                  _c("multiselect", {
                                    attrs: {
                                      id: "issues",
                                      "track-by": "id",
                                      label: "issue",
                                      multiple: "",
                                      placeholder: "",
                                      "close-on-select": false,
                                      disabled: _vm.formDisabledControl,
                                      options: _vm.issues,
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "selection",
                                        fn: function ({ values, isOpen }) {
                                          return [
                                            values.length && !isOpen
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "multiselect__single",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(values.length) +
                                                        " " +
                                                        _vm._s(
                                                          values.length > 1
                                                            ? "options"
                                                            : "option"
                                                        ) +
                                                        " selected\n                    "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.form.selectedIssues,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "selectedIssues",
                                          $$v
                                        )
                                      },
                                      expression: "form.selectedIssues",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "modal-card-solid-blue",
                          attrs: {
                            "header-html": "<b>Upload Image</b>",
                            "no-body": "",
                          },
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "px-3 py-2" },
                            [
                              _c("b-col", { staticClass: "py-3" }, [
                                _c("input", {
                                  ref: "file",
                                  attrs: {
                                    id: "imageInput",
                                    type: "file",
                                    multiple: "true",
                                    accept: "image/x-png,image/jpeg",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onImageSelected($event)
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _c("br"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.images, function (element) {
                            return _c(
                              "b-row",
                              { key: element.id, staticClass: "pl-3" },
                              [
                                _c(
                                  "label",
                                  { staticClass: "pl-3 mb-1 labels" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          element.image_path.split("\\", 2)[1]
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "p-3" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "modal-card-solid-blue",
                          attrs: {
                            "header-html": "<b>Comments *</b>",
                            "no-body": "",
                          },
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "px-3 pt-3" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c("b-form-textarea", {
                                        attrs: {
                                          id: "comments",
                                          name: "textarea-input",
                                          rows: "9",
                                        },
                                        model: {
                                          value: _vm.form.comments,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "comments", $$v)
                                          },
                                          expression: "form.comments",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.formSubmitErrors.length
                ? _c(
                    "b-row",
                    { attrs: { id: "formSubmitErrorsWindow" } },
                    [
                      _c("b-col", { staticClass: "text-center" }, [
                        _c("span", [
                          _c("b", [
                            _vm._v("Please correct the following error(s):"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-group" },
                            _vm._l(_vm.formSubmitErrors, function (error) {
                              return _c(
                                "div",
                                {
                                  key: error,
                                  staticClass: "alert alert-danger",
                                },
                                [
                                  _c("li", { staticClass: "list-group-item" }, [
                                    _vm._v(_vm._s(error)),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.submitSuccess
                ? _c(
                    "b-row",
                    {
                      staticClass: "p-3",
                      attrs: { id: "submitSuccessWindow" },
                    },
                    [
                      _c("b-col", { staticClass: "text-center" }, [
                        _c("span", { staticClass: "alert alert-success" }, [
                          _c("b", [_vm._v(_vm._s(this.submitSuccess))]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "btn",
                            staticStyle: { color: "white" },
                            on: {
                              click: function ($event) {
                                return _vm.submitSuccessHide()
                              },
                            },
                          },
                          [
                            _c("fa", {
                              attrs: { icon: ["fas", "window-close"] },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.updateSuccessMsg
                ? _c(
                    "b-row",
                    {
                      staticClass: "p-3",
                      attrs: { id: "updateSuccessWindow" },
                    },
                    [
                      _c("b-col", { staticClass: "text-center" }, [
                        _c("span", { staticClass: "alert alert-success" }, [
                          _c("b", [_vm._v(_vm._s(this.updateSuccessMsg))]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "btn",
                            staticStyle: { color: "white" },
                            on: {
                              click: function ($event) {
                                return _vm.updateSuccessHide()
                              },
                            },
                          },
                          [
                            _c("fa", {
                              attrs: { icon: ["fas", "window-close"] },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              this.updateEntryID
                ? _c(
                    "b-row",
                    { staticClass: "p-3", attrs: { id: "updateBtns" } },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "float-right",
                              attrs: {
                                variant: "primary",
                                size: "lg",
                                type: "submit",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.isAdmin
                                    ? _vm.submitEntryUpdate()
                                    : _vm.checkForm()
                                },
                              },
                            },
                            [_vm._v("\n            Update Entry\n          ")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "secondary",
                                size: "lg",
                                type: "button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.cancelUpdate()
                                },
                              },
                            },
                            [_vm._v("\n            Cancel\n          ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "b-row",
                    { staticClass: "p-3", attrs: { id: "submitBtns" } },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "float-right",
                              attrs: {
                                variant: "primary",
                                size: "lg",
                                type: "submit",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.isAdmin
                                    ? _vm.submitForm()
                                    : _vm.checkForm()
                                },
                              },
                            },
                            [_vm._v("\n            Submit\n          ")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "secondary",
                                size: "lg",
                                type: "button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.clearForm()
                                },
                              },
                            },
                            [_vm._v("\n            Clear\n          ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }